/**
 * Breadcrumb di navigazione globale — visibile in tutte le sezioni.
 * Mappa la vista corrente (Zustand, niente react-router) in un percorso
 * cliccabile: i segmenti intermedi riportano alla vista padre, "Home"
 * porta al Cruscotto.
 */
import { ChevronRight, Home } from 'lucide-react';
import { useUiStore, type AppView } from '../../store/ui';

// Percorso per ogni vista; l'ultimo segmento è quello corrente (non cliccabile).
const PATHS: Record<string, { label: string; view?: AppView }[]> = {
  home: [{ label: 'Panoramica' }],
  dashboard: [{ label: 'Cruscotto' }],
  kpi: [{ label: 'Cruscotto', view: 'dashboard' }, { label: 'KPI Tag' }],
  list: [{ label: 'Posta', view: 'list' }, { label: 'Elenco' }],
  feed: [{ label: 'Posta', view: 'list' }, { label: 'Feed' }],
  search: [{ label: 'Posta', view: 'list' }, { label: 'Ricerca' }],
  folders: [{ label: 'Posta', view: 'list' }, { label: 'Cartelle' }],
  deletion: [{ label: 'Posta', view: 'list' }, { label: 'In cancellazione' }],
  contacts: [{ label: 'Contatti' }],
  linkedin: [{ label: 'LinkedIn' }],
  saved: [{ label: 'LinkedIn', view: 'linkedin' }, { label: 'Salvati' }],
  changelog: [{ label: 'Novità' }],
  manuali: [{ label: 'Posta', view: 'list' }, { label: 'Manuale' }],
};

export function Breadcrumbs() {
  const currentView = useUiStore((s) => s.currentView);
  const setCurrentView = useUiStore((s) => s.setCurrentView);
  // 'settings' è un dialog sopra il Feed: mostra il percorso della vista sottostante.
  const path = PATHS[currentView] ?? PATHS.list;

  return (
    <nav
      aria-label="breadcrumb"
      className="flex h-8 shrink-0 items-center gap-1 border-b border-zinc-800/60 bg-zinc-950/60 px-4 text-xs text-zinc-400"
    >
      <button
        onClick={() => setCurrentView('home')}
        title="Vai alla Home"
        className="flex items-center gap-1 rounded px-1 py-0.5 hover:bg-zinc-800/60 hover:text-zinc-100"
      >
        <Home size={12} /> Home
      </button>
      {path.map((seg, i) => {
        const last = i === path.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            <ChevronRight size={12} className="text-zinc-600" />
            {last || !seg.view ? (
              <span className={last ? 'font-medium text-zinc-100' : ''}>{seg.label}</span>
            ) : (
              <button
                onClick={() => setCurrentView(seg.view as AppView)}
                className="rounded px-1 py-0.5 hover:bg-zinc-800/60 hover:text-zinc-100"
              >
                {seg.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
